import React from 'react';
import { AuthContext, ProfileContext } from './context';

const useAuth = () => React.useContext(AuthContext);

const useProfile = () => React.useContext(ProfileContext);

export { useAuth, useProfile };
